import React, {PureComponent} from 'react'
import {Link} from 'react-router-dom'

export default class Tag extends PureComponent {
    render() {
        return (
            <Link to={`/tag/${this.props.valueTag}`}>#{this.props.valueTag} </Link>
        )
    }
}